import script from "./EPeriodontalMapTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EPeriodontalMapTable.vue?vue&type=script&lang=ts&setup=true"

import "./EPeriodontalMapTable.vue?vue&type=style&index=0&id=a8338e00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8338e00"]])

export default __exports__